import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getTeamTasksAndStatsForCardViewNew } from 'services/task';

export const useGetTeamDataQuery = ({
  durationKey,
  limit,
  filters: activeFilters,
  tagType,
  tagId,
  type,
  startTS,
  endTS,
  timeBoundPeriod,
  selectedCohort,
}) =>
  useQuery(
    [REACT_QUERY_KEYS.goalsCardView, tagType, tagId, selectedCohort],
    () =>
      getTeamTasksAndStatsForCardViewNew({
        durationKey,
        limit,
        filters: activeFilters,
        tagType,
        tagId,
        type,
        startTS,
        endTS,
        timeBoundPeriod,
        selectedCohort,
      }),

    {
      enabled: Boolean(tagId && type),
    }
  );
